import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import { clone } from 'ramda'
import PaymentsActions, { PaymentsRedux, PaymentsTypes } from '../../Redux/ParentPlatform/PaymentsRedux'
import { notificationSuccess, notificationFail } from '../../Redux/NotificationActions'
import BalanceActions from '../../Redux/ParentPlatform/BalanceRedux'
import ChildrenActions from '../../Redux/ParentPlatform/ChildrenRedux'

const PaymentsCRUDObservable = createCRUDObservable({
  mainRedux: PaymentsRedux,
  reduxPath: 'parent_platform_payments',
})

const createPaymentEpic = (action$, store, { Api }) => (
  action$.ofType(PaymentsTypes.createPaymentRequest)
    .mergeMap(({ id, data }) => (
      Observable
      .fromPromise(Api.parent_platform_payments.createParentPayment(id, data)
        .then(response => response)
        .catch(err => err))
      .flatMap((response) => {
        const { status } = response
        if (!(status >= 200 && status < 300)) {
          return [
            PaymentsActions.createPaymentError(response.error),
            notificationFail('Accion Fallida'),
          ]
        }
        const page = 1
        const studentId = clone(store.getState().parent_platform_children.activeChildId)        
        return [
          PaymentsActions.createPaymentSuccess(response.data),
          BalanceActions.getMoreRequest({studentId , page }),
          ChildrenActions.getProfileRequest(studentId),
          notificationSuccess('Pago realizado'),
        ]
      })
    ))
)

export const paymentsObservers = Object.assign({}, PaymentsCRUDObservable.observers, {})
export const paymentsEpic = combineEpics(
  PaymentsCRUDObservable.epic,
  createPaymentEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ParentPlatform/PaymentsObservable.js